





























































import Vue from "vue";

import IconPasswordReset from "@joyz/app-core/assets/icons/default/ResetPassword.svg";
import AuthContainer from "@tt-app/components/user/auth/AuthContainer.vue";
import AuthError from "@tt-app/components/user/auth/AuthError.vue";

import AuthCard from "@tt-app/components/user/auth/AuthCard.vue";
import PasswordInputWithTooltip from "@tt-app/components/user/auth/PasswordInputWithTooltip.vue";
import PasswordConfirmationWithTooltip from "@tt-app/components/user/auth/PasswordConfirmationWithTooltip.vue";
import { ROUTES } from "@tt-app/constants/router";
import { TTFormInputValue, PageStatus, PayloadPwdChngReset } from "@tt-app/models";
import { VUEX_USER_NAMESPACE, VUEX_USER_ACTION_NAMES } from "@tt-app/constants";

const { PASSWORD_RESET } = VUEX_USER_ACTION_NAMES;
const {
  HOME,
  USER: { AUTHENTICATION }
} = ROUTES;

interface Data {
  jwt?: string;
  pageStatus: PageStatus;
  password: TTFormInputValue<string>;
  passwordConfirm: TTFormInputValue<string>;
  passwordError: string;
  processing: boolean;
}

interface Computed {
  authToken: string;
  isFormValid: boolean;
  iconResetPassword: string;
  jwtValidationError: string;
  pwdResetError: string;
  resetToken: string;
}
interface Method {
  handleAuthenticationStatusChange: () => void;
  validateJwt: () => Promise<void>;
  submitPwdReset: () => Promise<void>;
}

export default Vue.extend<Data, Method, Computed, {}>({
  name: "PwdChangeFromRequest",
  components: {
    AuthCard,
    AuthContainer,
    AuthError,
    PasswordInputWithTooltip,
    PasswordConfirmationWithTooltip
  },

  data() {
    return {
      jwt: this.$router.currentRoute.query.token as string,
      loginRouteName: AUTHENTICATION.LOGIN.NAME,
      password: { value: "", error: "" },
      passwordConfirm: { value: "", error: "" },
      pageStatus: "initial",
      passwordError: "",
      processing: false
    };
  },

  computed: {
    isFormValid() {
      return (
        !!this.password.value &&
        !!this.passwordConfirm.value &&
        this.password.value === this.passwordConfirm.value
      );
    },
    resetToken() {
      return this.$route.query["token"] as string;
    },
    pwdResetError() {
      const storedError = this.$store.state.user.pwdReset.error;
      return this.$__(storedError) || storedError;
    },
    authToken() {
      return this.$store.state.user.authentication.token;
    },
    iconResetPassword() {
      return IconPasswordReset;
    },
    jwtValidationError() {
      return this.$store.state.user.authentication.jwtValidationError;
    }
  },

  watch: {
    "passwordConfirm.value": {
      handler() {
        this.passwordConfirm.error =
          this.password.value !== this.passwordConfirm.value
            ? this.$__("user.pwd-reset.err.mismatch")
            : "";
      },
      immediate: false
    },
    authToken: {
      handler() {
        this.handleAuthenticationStatusChange();
      }
    }
  },

  created() {
    this.validateJwt();
  },

  methods: {
    async submitPwdReset() {
      if (!this.isFormValid) {
        return;
      }

      this.pageStatus = "loading";

      const action = `${VUEX_USER_NAMESPACE}/${PASSWORD_RESET}`;
      const payload: PayloadPwdChngReset = {
        token: this.resetToken,
        password: this.password.value
      };
      await this.$store.dispatch(action, payload);

      this.pageStatus = "loaded";
    },

    // Copied from Login.vue
    handleAuthenticationStatusChange() {
      if (this.authToken) {
        const nextPath = (this.$route.query.nextPath as string) || HOME.PATH;
        this.$router.replace({ path: nextPath });
      }
    },

    async validateJwt() {
      this.processing = true;
      if (this.jwt) {
        await this.$store.dispatch(
          `${VUEX_USER_NAMESPACE}/${VUEX_USER_ACTION_NAMES.VALIDATE_RESET_PASSWORD_JWT_REQUEST}`,
          { jwt: this.jwt }
        );
      }
      this.processing = false;
    }
  }
});
